import { addYears, format, subMonths } from 'date-fns'
import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import pricesAccepted from '../../actions/price/pricesAccepted'
import { IRequestPrices } from '../../actions/price/requestPrices'
import { fireToastError } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import fetchPrices from '../../models/Price/fetchPrices'
import { PriceGridAction } from '../../reducers/price/actionNames'
import { getUserObjectId } from '../../reducers/userObject/selectors/object'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import fetchMultiPrices from '../../models/Price/fetchMultiPrices'
import toggleMultiPrices from '../../models/Price/toggleMultiPrices'

function* getPrices(action: IRequestPrices) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchPrices)
    let { selectedRooms } = action
    // We prevent query string from being too long
    if (selectedRooms && selectedRooms.length > 100) {
      selectedRooms = []
    }
    const [{ calendarId, service }, objectId] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.select(getUserObjectId),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchPrices),
      ),
    ])

    if (!objectId || !calendarId) {
      yield Effects.delay(200)
      yield* getPrices(action)
      return
    }

    const startDate = format(subMonths(new Date(), 1), 'YYYY-MM-DD')
    const finishDate = format(addYears(new Date(), 2), 'YYYY-MM-DD')

    const prices = yield Effects.call(
      service,
      objectId,
      calendarId,
      startDate,
      finishDate,
      1,
      selectedRooms,
    )
    yield Effects.put(pricesAccepted(prices, selectedRooms))
  } catch (e) {
    //console.error(e)
    yield Effects.put(
      fireToastError(
        i18n.t('error_server_response_2'),
        5000,
        'Main',
        'ServerError',
      ),
    )
  }
}

export function* getNewPrices(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchNewPrices)

    const [{ calendarId, service }, objectId] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.select(getUserObjectId),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchMultiPrices),
      ),
    ])

    if (!objectId || !calendarId) {
      yield Effects.delay(200)
      yield* getNewPrices(action)
      return
    }

    const prices = yield Effects.call(
      service,
      objectId,
      calendarId
    )

    yield Effects.put({type: PriceGridAction.PricesNewAccepted, prices})
  } catch (e) {
    //console.error(e)
    yield Effects.put(
      fireToastError(
        i18n.t('error_server_response_2'),
        5000,
        'Main',
        'ServerError',
      ),
    )
  }
}

function* setPricesMultiOn(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.ToggleMultiPrices)
    const [{ calendarId, service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, toggleMultiPrices),
      ),
    ])


     yield Effects.call(
      service,
      1,
      calendarId
    )
    //reload browser
    if ('routerHistory' in window) {
      if((window as any).routerHistory.location.pathname.includes('/price/set')) {
        window.location.reload()
      } else {
        ;(window as any).routerHistory.push('/price/configuration', {})
      }
    }
  } catch (e) {
    //console.error(e)
    yield Effects.put(
      fireToastError(
        i18n.t('error_server_response_2'),
        5000,
        'Main',
        'ServerError',
      ),
    )
  }
}

export default function*() {
  yield Effects.takeLatest(PriceGridAction.RequestPrices, getPrices)
  yield Effects.takeLatest(PriceGridAction.RequestNewPrices, getNewPrices)
  yield Effects.takeLatest(PriceGridAction.TogglePricesMulti, setPricesMultiOn)
}
